import { Delete as DeleteIcon } from '@mui/icons-material';
import {
    Box,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import { getIcon, openAttachment } from '../../../../../../../utils/attachment';
import FileUploader from '../../../../../../FileUploader';

const useStyles = makeStyles({
    listItemText: {
        overflowWrap: 'break-word',
    },
});

export default function Attachments({
    addAttachment,
    apmId,
    disabled,
    fields,
    id,
    locationInfoId,
    removeAttachment,
}) {
    const classes = useStyles();

    return (
        <Box>
            <Typography variant="h6">Images</Typography>
            {fields.length > 0 && (
                <List id={`${id}List`}>
                    {fields.map((field, i) => {
                        const file = fields.value[i];
                        return (
                            <React.Fragment key={field}>
                                <ListItem
                                    button
                                    id={`${id}${i}`}
                                    onClick={() =>
                                        openAttachment(
                                            `apms/${apmId}/location-info/${locationInfoId}/attachment/${file.id}`
                                        )
                                    }
                                    target="_blank"
                                >
                                    <ListItemIcon id={`${id}${i}Icon`}>
                                        {getIcon(file.contentType)}
                                    </ListItemIcon>
                                    <ListItemText
                                        className={classes.listItemText}
                                        id={`${id}${i}Text`}
                                        primary={file.filename}
                                        primaryTypographyProps={{
                                            noWrap: true,
                                        }}
                                    />
                                    {!disabled && (
                                        <ListItemSecondaryAction>
                                            <IconButton
                                                edge="end"
                                                id={`${id}Attachment${i}DeleteButton`}
                                                onClick={() => removeAttachment(fields, i)}
                                                size="large"
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    )}
                                </ListItem>
                                <Divider component="li" id={`${id}${i}Divider`} />
                            </React.Fragment>
                        );
                    })}
                </List>
            )}
            <FileUploader
                accept="image/*"
                addFile={file => addAttachment(fields, file)}
                disabled={disabled}
                label="Upload image"
            />
        </Box>
    );
}
